import { Button, Collapse, Input, Radio, Row, Space } from "antd";
import React from "react";
import { _Filter_Types, _Filters_Handlers } from "./";
import { CustomCheckbox, CustomMinMax, Recursive } from "./CustomComponents";
import TenantCheckBox from "./CustomComponents/TenantCheckbox";
const SelectedPanelColor = "#bae7ff";
const { Panel } = Collapse;
const _MenyItemsStyle = { width: 256 };

const _Filter_Items = {
	[_Filter_Types.Text]: ({ _Label, _ApiTag, _extra, tenant, _placeholder, value, _SectionApiTag, dispatch }) => {
		return (
			<>
				<Collapse
					defaultActiveKey={["1"]}
					onChange={() => {}}
					style={{ "background-color": value ? SelectedPanelColor : "#f0f0f0f0" }}
				>
					<Panel
						extra={[
							<>
								{_extra && (
									<TenantCheckBox
										tenant={tenant}
										_ApiTag={_ApiTag}
										_extra={_extra}
										dispatch={dispatch}
									/>
								)}
							</>
						]}
						header={_Label}
						_placeholder
						key={_ApiTag}
					>
						<Input
							key={_ApiTag}
							type="text"
							placeholder={_placeholder}
							value={value}
							onChange={e =>
								_Filters_Handlers[_Filter_Types.Text]({
									dispatch,
									_SectionApiTag,
									_ApiTag,

									value: e.target.value
								})
							}
						/>
					</Panel>
				</Collapse>
			</>
		);
	},
	[_Filter_Types.Input]: ({ _Label, _ApiTag, _placeholder, _Child_ApiTag, value, _SectionApiTag, dispatch }) => {
		return (
			<>
				<div>
					{<h5>{_Label}</h5>}

					<Input
						key={_ApiTag}
						type="text"
						placeholder={_placeholder}
						value={value}
						onChange={e => {
							const value = e.target.value;
							_Filters_Handlers[_Filter_Types.Input]({
								dispatch,
								_SectionApiTag,
								_ApiTag,
								_Child_ApiTag,
								value
							});
						}}
					/>
				</div>
			</>
		);
	},
	[_Filter_Types.MINMAX]: probs => <CustomMinMax {...probs} />,
	[_Filter_Types.Checkbox]: probs => <CustomCheckbox {...probs} />,

	[_Filter_Types.Radio]: ({ _Label, _ApiTag, _Childrens, value, _SectionApiTag, dispatch }) => {
		return (
			<>
				<Collapse
					defaultActiveKey={["1"]}
					onChange={() => {}}
					style={{ "background-color": value ? SelectedPanelColor : "#f0f0f0f0" }}
				>
					<Panel
						// extra={<Badge count={10} style={{ backgroundColor: "#1890ff " }}></Badge>}
						header={_Label}
						key={_ApiTag}
					>
						{/* {getTitle(_Label)} */}
						<Row>
							<Radio.Group
								onChange={e =>
									_Filters_Handlers[_Filter_Types.Radio]({
										dispatch,
										_SectionApiTag,
										_ApiTag,
										_Child_ApiTag: e.target.value
									})
								}
								value={value}
							>
								<Space direction="vertical" size="small" style={{ display: "flex" }} align="left">
									{_Childrens.map(({ _ApiTag: _Child_ApiTag, _Label: _Child_Label }) => {
										return <Radio value={_Child_ApiTag}>{_Child_Label}</Radio>;
									})}
								</Space>
							</Radio.Group>
						</Row>
					</Panel>
				</Collapse>
			</>
		);
	},
	[_Filter_Types.Button]: ({ _Label }) => {
		return <Button style={_MenyItemsStyle}>{_Label}</Button>;
	},
	[_Filter_Types.Recursive]: probs => <Recursive {...probs} />
};

export default _Filter_Items;
